import { writable } from "svelte/store";
import dictionaryES from "./dictionary/dictionary-ES";

export const language = writable("es");
export const dictionary = writable(dictionaryES);
